export const SalasMultimediaImg = [
  {
    title: 'Salas Multimedia',
    path: '../../soluciones/salas-multimedia/img1.jpg',
    cName: 'carousel-img-salas-multimedia img1'
  },
  {
    title: 'Salas Multimedia',
    path: '../../soluciones/salas-multimedia/img2.jpg',
    cName: 'carousel-img-salas-multimedia img2'
  },
  {
    title: 'Salas Multimedia',
    path: '../../soluciones/salas-multimedia/img3.jpg',
    cName: 'carousel-img-salas-multimedia img3'
  },
  {
    title: 'Salas Multimedia',
    path: '../../soluciones/salas-multimedia/img4.jpg',
    cName: 'carousel-img-salas-multimedia img4'
  },
  {
    title: 'Salas Multimedia',
    path: '../../soluciones/salas-multimedia/img5.jpg',
    cName: 'carousel-img-salas-multimedia img5'
  },
  {
    title: 'Salas Multimedia',
    path: '../../soluciones/salas-multimedia/img6.jpg',
    cName: 'carousel-img-salas-multimedia img6'
  },
]